import { render, staticRenderFns } from "./SiteBackground.vue?vue&type=template&id=198a4d48"
import script from "./SiteBackground.vue?vue&type=script&lang=js"
export * from "./SiteBackground.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports